import Plyr from 'plyr';

export default class VideoSection {
    constructor() {
        console.log('%c👍🏼 Video Section', 'color: yellow');

        this.videos = document.querySelectorAll('.video-section');
    }
    init() {
        this.videos.forEach((elem, i) => {

            let video = elem.querySelector('.plyr__video__wrapper');
            let playButton =  elem.querySelector('.video-section__button');            

            playButton.addEventListener('click', () => {
                // if (!Cookiebot.consent.marketing) {
                //     Cookiebot.show();
                //     return;
                // }

                elem.classList.add('hide');

                const player = new Plyr(video, {
                    autoplay: true,
                    vimeo: {
                        autoplay:true
                    },
                    youtube: {
                        autoplay:1,
                        playsinline:1
                    }
                });

                player.volume = 0.5;
                player.play();

                let observer = new IntersectionObserver((entries) => { 
                    entries.forEach(entry => {
                        if(entry.intersectionRatio!=1){
                            player.pause();
                        }
                    
                    });
                }, {threshold: 1});
                observer.observe(video);
            });
        })
    }
}